module.exports = __webpack_public_path__ + "static/media/pantip.85d77f87.png";